<template>
  <div id="data-list-list-view" class="data-list-container">
    <add-new-data-sidebar
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="addNewDataSidebar = false"
      :form="formSideBar"
      :title="titleSideBar"
      :dados="dataSideBar"
      @concluido="finished"
    />

    <vs-table
      noDataText="Nenhuma Origem de cotação Encontrada"
      class="tablePrincipal"
      ref="table"
      multiple
      v-model="selected"
      :max-items="itemsPerPage"
      :data="itens"
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div class="flex flex-wrap-reverse items-center">
          <div
            class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between font-medium text-base text-primary border border-solid border-primary"
            @click="openSideBar({})"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary"
              >Adicionar nova Origem de Cotação</span
            >
          </div>
        </div>

        <div class="flex">
          <SelectPagination
            v-if="itens.length > 0"
            :currentPage="currentPage"
            :itemsPerPage="itemsPerPage"
            :length="count"
            @update="updateSelectPagination"
          />

          <vs-input
            icon="search"
            placeholder="Nome ou Chave"
            v-model="searchQuery"
          />
        </div>
      </div>

      <template slot="thead">
        <vs-th sort-key="razaoSocial">Nome</vs-th>
        <vs-th sort-key="cpfCnpj">Chave Única</vs-th>
        <vs-th sort-key="deletedAt">Status</vs-th>
        <vs-th>Ações</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p>{{ tr.name }}</p>
            </vs-td>

            <vs-td>
              <p>{{ tr.key }}</p>
            </vs-td>

            <vs-td>
              <vs-chip
                :color="getStatusColor(tr.deletedAt)"
              >
                {{ getStatusString(tr.deletedAt) }}
              </vs-chip>
            </vs-td>
            <vs-td>
              <p>
                <vs-button
                  radius
                  v-tooltip="'Editar'"
                  color="success"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-edit"
                  class="d-inline"
                  @click="openSideBar(tr)"
                ></vs-button>
              </p>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <div class="mt-6">
      <vs-pagination
        :total="parseInt(count / itemsPerPage) + 1"
        v-model="currentPage"
      ></vs-pagination>
    </div>
  </div>
</template>
<script>
import AddNewDataSidebar from '@/views/Includes/SideBar.vue';
import SelectPagination from '@/utils/list/header/SelectPagination.vue';
import originSystemApi from '@/services/origin.system.api';
import functions from '@/utils/functions';
import notify from '@/utils/notify';

export default {
  name: 'ListOriginSystem',
  components: {
    AddNewDataSidebar,
    SelectPagination,
  },
  data() {
    return {
      addNewDataSidebar: false,
      formSideBar: 'OriginSystemForm',
      titleSideBar: 'Adicionar Origem de Cotação',
      dataSideBar: {},
      selected: [],
      itens: [],
      count: 0,
      currentPage: 1,
      itemsPerPage: 50,
      searchQuery: '',
      entity: 'Origem de Cotação',
      debounce: functions.debounce(this.fetchData, 1000),
    };
  },
  methods: {
    fetchData() {
      originSystemApi
        .getOriginSystems({
          page: this.currentPage,
          items_per_page: this.itemsPerPage,
          search: this.searchQuery,
        })
        .then((data) => {
          this.itens = data.items;
          this.count = data.total;
        })
        .catch((error) => {
          notify.notifyFail(this.$vs, error);
        });
    },
    openSideBar(data) {
      data.id
        ? (this.titleSideBar = `Editar ${this.entity}`)
        : (this.titleSideBar = `Adicionar ${this.entity}`);
      this.dataSideBar = data;
      this.addNewDataSidebar = true;
    },
    finished() {
      this.fetchData();
    },
    updateSelectPagination(value) {
      this.resetCurrentPage()
      this.itemsPerPage = value;
    },
    resetCurrentPage() {
      this.currentPage = 1;
    },
    getStatusColor(data) {
      if (data == null) return 'success';
      return 'danger';
    },
    getStatusString(data) {
      if (data == null) return 'Ativo';
      return 'Inativo';
    },
  },
  async mounted() {
    await this.fetchData();
  },
  watch: {
    searchQuery: {
      immediate: true,
      handler: function () {
        this.resetCurrentPage()
        this.debounce();
      },
    },
    currentPage: {
      immediate: true,
      handler: function () {
        this.debounce();
      },
    },
    itemsPerPage: {
      immediate: true,
      handler: function () {
        this.currentPage = 1;
        this.fetchData();
      },
    },
  },
};
</script>
